export const DISCOUNT_TYPE_PERCENT = "percent"
export const DISCOUNT_TYPE_AMOUNT_OF_SUBTOTAL = "amount-off-subtotal"
export const DISCOUNT_TYPE_NIGHTLY_AMOUNT_OFF = "nightly-amount-off"
export const DISCOUNT_TYPE_FLAT_RATE = "flat-rate"

export type DiscountType =
  | typeof DISCOUNT_TYPE_PERCENT
  | typeof DISCOUNT_TYPE_AMOUNT_OF_SUBTOTAL
  | typeof DISCOUNT_TYPE_NIGHTLY_AMOUNT_OFF
  | typeof DISCOUNT_TYPE_FLAT_RATE

export const ACTIVE_DATE_TYPE_NO_EXPIRATION = "no-expiration"
export const ACTIVE_DATE_TYPE_WITH_EXPIRATION = "with-expiration"

export const RESERVATION_DATES_EXPIRATION = "reservation-dates"
export const BOOKING_DATES_EXPIRATION = "booking-dates"

export type ActiveDatesType = typeof ACTIVE_DATE_TYPE_NO_EXPIRATION | typeof ACTIVE_DATE_TYPE_WITH_EXPIRATION

export type ExpirationByType = typeof RESERVATION_DATES_EXPIRATION | typeof BOOKING_DATES_EXPIRATION

export type ExpirationByConstType = { label: string; value: ExpirationByType; tooltip?: string }

export const discountTypes: { label: string; value: DiscountType }[] = [
  { label: "Percent", value: DISCOUNT_TYPE_PERCENT },
  { label: "Amount off subtotal", value: DISCOUNT_TYPE_AMOUNT_OF_SUBTOTAL },
  { label: "Nightly amount off", value: DISCOUNT_TYPE_NIGHTLY_AMOUNT_OFF },
  { label: "Flat rate", value: DISCOUNT_TYPE_FLAT_RATE },
]

export const activeDatesTypes: { label: string; value: ActiveDatesType }[] = [
  { label: "No expiration", value: ACTIVE_DATE_TYPE_NO_EXPIRATION },
  { label: "With expiration", value: ACTIVE_DATE_TYPE_WITH_EXPIRATION },
]

export const expirationByOptions: ExpirationByConstType[] = [
  {
    label: "Reservation Dates",
    value: RESERVATION_DATES_EXPIRATION,
    tooltip:
      "Coupon can be applied for any reservation fully inside the selected date range, regardless of when the reservation is booked.",
  },
  {
    label: "Booking Dates",
    value: BOOKING_DATES_EXPIRATION,
    tooltip:
      "Coupon can be applied for any reservation booked inside the selected date range, regardless of the reservation dates.",
  },
]
